import { useCallback } from "react";

export interface WidgetNavigateEvent extends CustomEvent {
  detail: {
    url: string;
  };
}

export const WIDGET_NAVIGATE_EVENT = "circle:widget-navigate";

export const useWidgetNavigate = () => {
  const navigate = useCallback((url: string) => {
    const event: WidgetNavigateEvent = new CustomEvent(WIDGET_NAVIGATE_EVENT, {
      bubbles: true,
      cancelable: true,
      composed: false,
      detail: {
        url,
      },
    });

    document.dispatchEvent(event);
  }, []);

  return navigate;
};
